function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function checkIcon() {
  return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"></path></svg>`;
}

function mediaHtml(block) {
  if (block.type === "media" && block.src) {
    return `<figure class="tutorial-media"><img src="${escapeHtml(block.src)}" alt="${escapeHtml(block.alt ?? "")}"></figure>`;
  }
  if (block.type !== "animation") return "";
  return `<figure class="tutorial-demo tutorial-demo-${escapeHtml(block.variant ?? "target")}" aria-hidden="true">
    <span class="tutorial-demo-map"></span>
    <span class="tutorial-demo-building"></span>
    <span class="tutorial-demo-path"></span>
    <span class="tutorial-demo-survivor"></span>
    <span class="tutorial-demo-cone"></span>
  </figure>`;
}

function lessonBodyHtml(lesson) {
  return (lesson.body ?? []).map((block) => {
    if (block.type === "paragraph") return `<p>${escapeHtml(block.text)}</p>`;
    if (block.type === "callout") return `<p class="tutorial-callout">${escapeHtml(block.text)}</p>`;
    return mediaHtml(block);
  }).join("");
}

export function createTutorialView({ boxElement, modalElement, onComplete }) {
  let lessons = [];
  let activeLessonId = null;

  const lessonById = (lessonId) => lessons.find((lesson) => lesson.id === lessonId) ?? null;

  function openLesson(lessonId) {
    const lesson = lessonById(lessonId);
    if (!lesson || !modalElement) return;
    activeLessonId = lesson.id;
    modalElement.querySelector("[data-tutorial-modal-title]").textContent = lesson.title;
    modalElement.querySelector("[data-tutorial-modal-body]").innerHTML = lessonBodyHtml(lesson);
    if (typeof modalElement.showModal === "function") modalElement.showModal();
    else modalElement.hidden = false;
  }

  function closeLesson() {
    if (modalElement?.open) modalElement.close();
    else if (modalElement) modalElement.hidden = true;
  }

  boxElement?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-tutorial-lesson-id]");
    if (!button) return;
    openLesson(button.dataset.tutorialLessonId);
  });

  modalElement?.querySelector("[data-tutorial-modal-close]")?.addEventListener("click", closeLesson);
  modalElement?.addEventListener("close", () => {
    if (!activeLessonId) return;
    const lessonId = activeLessonId;
    activeLessonId = null;
    onComplete?.(lessonId);
  });

  return {
    render({ enabled, visibleLessons }) {
      lessons = visibleLessons ?? [];
      if (!boxElement) return;
      boxElement.hidden = !enabled || lessons.length === 0;
      if (boxElement.hidden) {
        boxElement.innerHTML = "";
        return;
      }
      const completeCount = lessons.filter((lesson) => lesson.complete).length;
      boxElement.innerHTML = `
        <div class="tutorial-box-head">
          <b>Tutorial</b>
          <span>${completeCount}/${lessons.length}</span>
        </div>
        <ol class="tutorial-lesson-list">
          ${lessons.map((lesson) => `
            <li>
              <button type="button" class="${lesson.complete ? "complete" : ""}" data-tutorial-lesson-id="${escapeHtml(lesson.id)}">
                <span class="tutorial-check">${lesson.complete ? checkIcon() : ""}</span>
                <span class="tutorial-title">${escapeHtml(lesson.title)}</span>
              </button>
            </li>`).join("")}
        </ol>`;
    },
  };
}
